import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'range',
  standalone: false,
})
export class RangePipe implements PipeTransform {
  transform(field: string, range: { name: string; from: string; to: string }): any {
    const rangeToValue = range.to ? `&${field}${range.to}` : ''
    return field + range.from + rangeToValue
  }
}
